
import { useEffect, useState } from 'react';

export default function ServicesSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('servicos');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: 'ri-file-text-line',
      title: 'Contabilidade Fiscal',
      description: 'Gestão completa das obrigações fiscais da sua empresa com total conformidade legal.',
      color: 'from-blue-500 to-blue-600',
      dotColor: 'bg-blue-500',
      topics: [
        'Apuração de impostos',
        'Declarações obrigatórias',
        'Planejamento fiscal',
        'Acompanhamento de prazos'
      ]
    },
    {
      icon: 'ri-calculator-line',
      title: 'Contabilidade Geral',
      description: 'Escrituração contábil completa e relatórios gerenciais para tomada de decisões.',
      color: 'from-green-500 to-green-600',
      dotColor: 'bg-green-500',
      topics: [
        'Balanços e demonstrações',
        'Conciliações bancárias',
        'Controle patrimonial',
        'Relatórios gerenciais'
      ]
    },
    {
      icon: 'ri-group-line',
      title: 'Departamento Pessoal',
      description: 'Gestão completa de recursos humanos e folha de pagamento da sua empresa.',
      color: 'from-purple-500 to-purple-600',
      dotColor: 'bg-purple-500',
      topics: [
        'Folha de pagamento',
        'Admissões e demissões',
        'Benefícios e férias',
        'Obrigações trabalhistas'
      ]
    },
    {
      icon: 'ri-building-line',
      title: 'Abertura de Empresa',
      description: 'Processo completo de abertura de empresa de forma rápida e descomplicada.',
      color: 'from-orange-500 to-orange-600',
      dotColor: 'bg-orange-500',
      topics: [
        'Consulta de viabilidade',
        'Registro na Junta Comercial',
        'Inscrições municipais',
        'Licenças necessárias'
      ]
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Planejamento Tributário',
      description: 'Estratégias para redução legal da carga tributária e otimização fiscal.',
      color: 'from-red-500 to-red-600',
      dotColor: 'bg-red-500',
      topics: [
        'Análise tributária',
        'Escolha do regime',
        'Elisão fiscal',
        'Recuperação de créditos'
      ]
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'BPO Financeiro',
      description: 'Terceirização completa dos processos financeiros da sua empresa.',
      color: 'from-teal-500 to-teal-600',
      dotColor: 'bg-teal-500',
      topics: [
        'Contas a pagar/receber',
        'Fluxo de caixa',
        'Conciliações',
        'Controles financeiros'
      ]
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Consultoria',
      description: 'Orientação especializada para crescimento e otimização do seu negócio.',
      color: 'from-indigo-500 to-indigo-600',
      dotColor: 'bg-indigo-500',
      topics: [
        'Análise de viabilidade',
        'Reestruturação societária',
        'Consultoria estratégica',
        'Orientação empresarial'
      ]
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Compliance',
      description: 'Garantia de conformidade com todas as normas e regulamentações vigentes.',
      color: 'from-pink-500 to-pink-600',
      dotColor: 'bg-pink-500',
      topics: [
        'Auditoria interna',
        'Controles internos',
        'Gestão de riscos',
        'Adequação normativa'
      ]
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">


<div className="text-center mb-12 py-8 bg-gradient-to-r from-[#006bbb]/10 to-transparent rounded-2xl">
  <h2 className="text-sm font-semibold text-[#006bbb] uppercase tracking-widest mb-2">
    Nossos Serviços
  </h2>
  <h3 className="text-4xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
    Soluções Contábeis que dão resultados
  </h3>

  {/* Faixa azul ampliada */}
  <div className="w-90 h-2 bg-[#006bbb] mx-auto rounded-full mb-4"></div>

  <p className="text-gray-500 max-w-2xl mx-auto">
    Conheça nossos serviços feitos para simplificar sua gestão e otimizar seus resultados.
  </p>
</div>


        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group bg-white/30 backdrop-blur-sm rounded-xl p-6 border border-white/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 transform ${
                isVisible 
                  ? 'translate-y-0 opacity-100' 
                  : 'translate-y-10 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className={`w-16 h-16 bg-gradient-to-r ${service.color} rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                {service.title}
              </h3>
              
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.topics.map((topic, topicIndex) => (
                  <li key={topicIndex} className="flex items-center text-sm text-gray-600">
                    <div className={`w-1.5 h-1.5 ${service.dotColor} rounded-full mr-2 flex-shrink-0`}></div>
                    {topic}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
